import { AuthSection } from './AuthSection';

export default AuthSection;
